(function () {
  'use strict';

  // ── STORAGE ───────────────────────────────────────────────────
  var STORAGE_KEY = 'sucursal_store';

  function getState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  // El default (Bogotá / LA 95) es una suposición nuestra, no una elección del
  // usuario. `confirmado` distingue ambos casos: mientras sea false el
  // add-to-cart pide confirmar tienda; una vez true no se vuelve a preguntar,
  // sin importar si se quedó en LA 95 o cambió a otra.
  function isConfirmado() {
    var state = getState();
    return !!(state && state.id && state.confirmado);
  }

  function saveState(state) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));

      // Cookie accesible desde Liquid server-side
      var expires = new Date(Date.now() + 86400000).toUTCString();

      document.cookie = 'sucursal_id=' + encodeURIComponent(state.id || '') + '; path=/; expires=' + expires;
      document.cookie = 'sucursal_ciudad=' + encodeURIComponent(state.ciudad || '') + '; path=/; expires=' + expires;
      document.cookie = 'sucursal_nombre=' + encodeURIComponent(state.nombre || '') + '; path=/; expires=' + expires;
      document.cookie = 'sucursal_envio=' + encodeURIComponent(state.envio || '') + '; path=/; expires=' + expires;
    } catch (e) {}
  }

  // ── SUCURSAL POR DEFECTO ──────────────────────────────────────
  // Si el usuario nunca ha elegido tienda, arrancamos en Bogotá / LA 95 con
  // envío "regular" en vez de dejar la sesión sin sucursal. Así la home, las
  // colecciones y el carrito tienen inventario y precios desde la primera
  // carga, y el modal deja de ser un bloqueo obligatorio.
  //
  // El ID de la location NO se hardcodea: se resuelve contra el App Proxy
  // buscando la tienda dentro de la ciudad, de modo que siga funcionando si
  // Shopify reasigna IDs de location.
  var DEFAULT_SUCURSAL = {
    ciudad: 'Bogotá',
    // Se prueban en orden hasta encontrar coincidencia en el listado real.
    nombreMatches: ['la 95', '95'],
    envio: 'regular'
  };

  function normalizar(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '');
  }

  // "Bogotá, D.C." y "Bogotá" deben considerarse la misma ciudad.
  function ciudadCoincide(candidata, objetivo) {
    var a = normalizar(candidata);
    var b = normalizar(objetivo);
    if (!a || !b) return false;
    return a === b || a.indexOf(b) === 0 || b.indexOf(a) === 0;
  }

  function elegirCiudadDefault(ciudades) {
    for (var i = 0; i < ciudades.length; i++) {
      if (ciudadCoincide(ciudades[i], DEFAULT_SUCURSAL.ciudad)) return ciudades[i];
    }
    return null;
  }

  // Preferimos coincidencia exacta ("LA 95") antes que parcial, para no caer
  // en "109" u otra tienda cuyo nombre contenga el número.
  function elegirTiendaDefault(sucursales) {
    if (!sucursales || !sucursales.length) return null;

    var matches = DEFAULT_SUCURSAL.nombreMatches;

    for (var m = 0; m < matches.length; m++) {
      var objetivo = normalizar(matches[m]);

      for (var i = 0; i < sucursales.length; i++) {
        if (normalizar(sucursales[i].nombre) === objetivo) return sucursales[i];
      }
    }

    for (var m2 = 0; m2 < matches.length; m2++) {
      var parcial = normalizar(matches[m2]);

      for (var j = 0; j < sucursales.length; j++) {
        var nombre = normalizar(sucursales[j].nombre);
        //  para no confundir "95" con "195"/"950".
        if (new RegExp('(^|[^0-9a-z])' + parcial + '([^0-9a-z]|$)').test(nombre)) {
          return sucursales[j];
        }
      }
    }

    return null;
  }

  // Resuelve y persiste la sucursal por defecto. Solo se llama cuando NO hay
  // estado previo: una elección del usuario nunca se sobrescribe.
  function aplicarSucursalDefault(ciudades) {
    var ciudad = elegirCiudadDefault(ciudades || []);

    if (!ciudad) return Promise.resolve(null);

    return fetch('https://sioconn.dislicores.com/poligonos/locations?ciudad=' + encodeURIComponent(ciudad))
      .then(function (r) { return r.json(); })
      .then(function (sucursales) {
        var tienda = elegirTiendaDefault(sucursales);

        if (!tienda) return null;

        var state = {
          id: tienda.id,
          nombre: tienda.nombre || '',
          ciudad: tienda.ciudad || ciudad,
          direccion: tienda.direccion || '',
          envio: DEFAULT_SUCURSAL.envio,
          // Sembrado por nosotros: aún falta que el usuario lo confirme.
          confirmado: false
        };

        saveState(state);
        updateHeader(state.nombre, state.envio);

        document.dispatchEvent(new CustomEvent('sucursal:changed', { detail: state }));

        window.dispatchEvent(
          new CustomEvent('branch:changed', {
            detail: { locationId: parseLocationId(state.id), sucursal: state }
          })
        );

        // Deja sucursal_id / sucursal_envio en cart.attributes para el cart
        // transform, price.liquid e Instaleap.
        return syncCart(state).then(function () { return state; });
      })
      .catch(function () { return null; });
  }

  // ── ELEMENTOS DEL DOM ─────────────────────────────────────────
  var overlay      = document.getElementById('sucursal-overlay');
  var chip         = document.getElementById('sucursal-chip');
  var headerName   = document.getElementById('sucursal-header-name');
  var btnClose     = document.getElementById('sucursal-close');
  var btnConfirm   = document.getElementById('sucursal-confirm');
  var selCiudad    = document.getElementById('sucursal-ciudad');
  var selTienda    = document.getElementById('sucursal-tienda');
  var storeInfo    = document.getElementById('sucursal-store-info');
  var infoNombre   = document.getElementById('sucursal-info-nombre');
  var infoDirec    = document.getElementById('sucursal-info-direccion');
  var detectedText = document.getElementById('sucursal-detected');
  var selEnvio = document.getElementById('sucursal-envio');
  var headerEnvio = document.getElementById('sucursal-header-envio');

  if (!overlay) return;

  if (!selCiudad || !selTienda || !btnConfirm) return;

  // ── EVITAR QUE EL MODAL CONTAMINE OTROS LISTENERS ─────────────
  function stopSucursalBubble(e) {
    e.stopPropagation();
  }

  ['click', 'change', 'input'].forEach(function (eventName) {
    overlay.addEventListener(eventName, stopSucursalBubble);
  });

  // ── SELECT CIUDAD ─────────────────────────────────────────────
  selCiudad.addEventListener('change', function (e) {
    e.stopPropagation();

    var ciudad = this.value;

    resetTienda();

    if (!ciudad) {
      return;
    }

    selTienda.disabled = true;

    var loadingOpt = document.createElement('option');
    loadingOpt.value = '';
    loadingOpt.textContent = 'Cargando tiendas...';
    selTienda.appendChild(loadingOpt);

    fetch('https://sioconn.dislicores.com/poligonos/locations?ciudad=' + encodeURIComponent(ciudad))
      .then(function (r) {
        return r.json();
      })
      .then(function (sucursales) {
        selTienda.innerHTML = '';
        selTienda.disabled = false;

        var placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = '— Selecciona una tienda —';
        selTienda.appendChild(placeholder);

        sucursales.forEach(function (s) {
          var opt = document.createElement('option');
          opt.value = s.id;
          opt.dataset.nombre = s.nombre || '';
          opt.dataset.direccion = s.direccion || '';
          opt.dataset.ciudad = s.ciudad || ciudad;
          opt.textContent = s.nombre || 'Sucursal';
          selTienda.appendChild(opt);
        });
      })
      .catch(function () {
        resetTienda();

        var errOpt = document.createElement('option');
        errOpt.value = '';
        errOpt.textContent = 'Error cargando tiendas. Intenta de nuevo.';
        selTienda.appendChild(errOpt);
      });
  });

  // ── SELECT TIENDA ─────────────────────────────────────────────
  selTienda.addEventListener('change', function (e) {
    e.stopPropagation();

    var opt = this.options[this.selectedIndex];

    if (!opt || !opt.value) {
      hideStoreInfo();
      return;
    }

    if (infoNombre) infoNombre.textContent = opt.dataset.nombre || '';
    if (infoDirec) infoDirec.textContent = opt.dataset.direccion || '';

    if (storeInfo) {
      storeInfo.classList.add('is-visible');
    }

    validarConfirmacion();
  });

  // NUEVO listener para el select de envío
  selEnvio.addEventListener('change', validarConfirmacion);

  function validarConfirmacion() {
    var tiendaOk = selTienda.value !== '';
    var envioOk  = selEnvio.value !== '';
    btnConfirm.disabled = !(tiendaOk && envioOk);
  }

  function resetTienda() {
    selTienda.innerHTML = '<option value="">— Primero selecciona ciudad —</option>';
    selTienda.disabled = true;
    hideStoreInfo();
  }

  function hideStoreInfo() {
    if (storeInfo) {
      storeInfo.classList.remove('is-visible');
    }

    btnConfirm.disabled = true;
  }

  var ENVIO_LABELS = {
    recogida: 'Recogida en tienda',
    express:  'Envío Express',
    regular:  'Envío Regular'
  };

  // ── CONFIRMAR ─────────────────────────────────────────────────
  btnConfirm.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var opt = selTienda.options[selTienda.selectedIndex];

    if (!opt || !opt.value) return;

    var state = {
      id: opt.value,
      nombre: opt.dataset.nombre || '',
      ciudad: opt.dataset.ciudad || selCiudad.value || '',
      direccion: opt.dataset.direccion || '',
      envio: selEnvio.value,
      confirmado: true
    };

    saveState(state);
    updateHeader(state.nombre, state.envio);
    closeModal();

    document.dispatchEvent(new CustomEvent('sucursal:changed', { detail: state }));

    // branch-collection.js escucha este evento para recargar las grillas
    // marcadas con [data-branch-grid] desde el App Proxy.
    window.dispatchEvent(
      new CustomEvent('branch:changed', {
        detail: { locationId: parseLocationId(state.id), sucursal: state }
      })
    );

    syncCart(state).finally(function () {
      // Si la confirmación vino de un add-to-cart interceptado, recargar aquí
      // abortaría ese add-to-cart: el usuario confirmaría y el producto nunca
      // entraría al carrito. El guard recarga por su cuenta al terminar.
      if (window.__sucursalPendingAdd) return;

      // En home y colección las grillas se repintan solas con branch:changed.
      // En el resto (PDP, carrito) sí recargamos: price.liquid calcula el
      // precio con impuestos por zona a partir de cart.attributes.sucursal_id
      // y necesita render server-side.
      if (!hasBranchGrids()) {
        window.location.reload();
      }
    });
  });

  function parseLocationId(gid) {
    if (!gid) return null;
    return String(gid).split('/').pop();
  }

  function hasBranchGrids() {
    return document.querySelector('[data-branch-grid]') !== null;
  }

  // ── HEADER ────────────────────────────────────────────────────
  function updateHeader(nombre, envio) {
    if (headerName) {
      headerName.textContent = nombre || '';
    }

    if (envio && headerEnvio) {
      headerEnvio.textContent = ENVIO_LABELS[envio] || envio;
      headerEnvio.style.display = 'inline-block';
    }
  }

  // ── SYNC CARRITO ──────────────────────────────────────────────
  function cartAttributesBody(state) {
    return JSON.stringify({
      attributes: {
        sucursal_id: state.id,
        sucursal_nombre: state.nombre,
        sucursal_ciudad: state.ciudad,
        sucursal_envio:  state.envio
      }
    });
  }

  // Escritura sin reintento, para no recursar desde syncCart
  function syncCartOnce(state) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: cartAttributesBody(state)
    }).catch(function () {});
  }

  function syncCart(state) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: cartAttributesBody(state)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/update ' + r.status);
        return r.json();
      })
      .catch(function (err) {
        console.warn('[sucursal] no se pudo sincronizar el carrito:', err);

        // Reintento único: el GET refresca la sesión de carrito, lo que cubre
        // la rotación del token al volver del checkout.
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function () { return syncCartOnce(state); })
          .catch(function () {});
      });
  }

  // ── RECONCILIAR ESTADO LOCAL ↔ CARRITO ────────────────────────
  // El header lee localStorage, pero el checkout lee cart.attributes. Se
  // desincronizan al volver del checkout, al vaciarse el carrito, o si
  // syncCart falló en su momento. Esto los realinea en cada carga.
  //
  // Nota: si el carrito está vacío Shopify no persiste atributos; en ese caso
  // la reconciliación no puede hacer nada, pero tampoco importa porque un
  // carrito vacío no llega al checkout. Al agregar el primer item, la
  // siguiente carga de página lo realinea.
  function reconcileCart() {
    var state = getState();

    if (!state || !state.id) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var attrs = cart.attributes || {};

        // También se compara sucursal_envio: Instaleap lo consume desde
        // cart.attributes, y un carrito con el id correcto pero sin envío
        // (o con uno viejo) llega mal al checkout.
        var alineado =
          attrs.sucursal_id === state.id &&
          attrs.sucursal_envio === state.envio;

        if (alineado) return;

        return syncCart(state);
      })
      .catch(function () {});
  }

  // ── ABRIR / CERRAR MODAL ──────────────────────────────────────
  function openModal(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    precargarEstado();
  }

  function closeModal() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // El modal solo bloquea el cierre cuando no hay ninguna tienda (ni siquiera
  // el default). Con default aplicado se puede cerrar libremente: la
  // confirmación se pide después, en el primer add-to-cart.
  function mustSelectStore() {
    var s = getState();
    return !s || !s.id;
  }

  function flashMustSelect() {
    if (detectedText) {
      detectedText.textContent = 'Selecciona tu ciudad y tienda para continuar';
    }
  }

  // Si hay estado guardado, pre-seleccionar en el modal
  function precargarEstado() {
    var state = getState();

    if (!state) {
      if (detectedText) {
        detectedText.textContent = 'SELECCIONA TU CIUDAD Y TIENDA';
      }

      return;
    }

    if (detectedText) {
      detectedText.textContent = 'Cambia tu tienda cuando quieras';
    }

    if (state.nombre) {
      updateHeader(state.nombre, state.envio);
    }

    if (state.ciudad) {
      selCiudad.value = state.ciudad;
      selCiudad.dispatchEvent(new Event('change', { bubbles: false }));

      setTimeout(function () {
        if (state.id) {
          selTienda.value = state.id;
          selTienda.dispatchEvent(new Event('change', { bubbles: false }));
        }

        if (state.envio) {
          selEnvio.value = state.envio;
          selEnvio.dispatchEvent(new Event('change'));
        }
      }, 500);
    }
  }

  // ── EVENTOS MODAL ─────────────────────────────────────────────
  if (chip) {
    chip.addEventListener('click', openModal);
  }

  if (btnClose) {
    btnClose.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (mustSelectStore()) { flashMustSelect(); return; }
      closeModal();
    });
  }

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) {
      if (mustSelectStore()) { flashMustSelect(); return; }
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (mustSelectStore()) return;
      closeModal();
    }
  });

  // ── POPUP AUTOMÁTICO ──────────────────────────────────────────
  function initAutoPopup() {
    var state = getState();

    if (state && state.nombre) {
      updateHeader(state.nombre, state.envio);
      return;
    }

    // Con sucursal por defecto el modal deja de ser obligatorio: solo se abre
    // si el default no pudo resolverse (App Proxy caído, ciudad ausente, etc.).
    setTimeout(function () {
      if (getState()) return;
      openModal();
    }, 3000);
  }

  // ── CARGAR CIUDADES ───────────────────────────────────────────
  function cargarCiudades() {
    fetch('https://sioconn.dislicores.com/poligonos/ciudades')
      .then(function (r) {
        return r.json();
      })
      .then(function (ciudades) {
        ciudades.forEach(function (ciudad) {
          var exists = Array.prototype.some.call(selCiudad.options, function (option) {
            return option.value === ciudad;
          });

          if (exists) return;

          var opt = document.createElement('option');
          opt.value = ciudad;
          opt.textContent = ciudad;
          selCiudad.appendChild(opt);
        });

        // Primera visita: sembramos Bogotá / LA 95 para que el sitio nunca
        // quede sin inventario ni sin sucursal_envio en el carrito.
        if (!getState()) {
          aplicarSucursalDefault(ciudades).then(function (state) {
            precargarEstado();

            // Repintar grillas ya renderizadas con la sucursal recién fijada.
            if (state && hasBranchGrids()) {
              window.dispatchEvent(
                new CustomEvent('branch:changed', {
                  detail: { locationId: parseLocationId(state.id), sucursal: state }
                })
              );
            }
          });

          return;
        }

        precargarEstado();
      })
      .catch(function (e) {
        console.log(e);

        var opt = document.createElement('option');
        opt.value = '';
        opt.textContent = 'Error cargando ciudades';
        selCiudad.appendChild(opt);
      });
  }

  // ── API PÚBLICA ───────────────────────────────────────────────
  // sucursal-atc-guard.js corre en otro closure y necesita saber si la tienda
  // actual ya fue confirmada por el usuario o sigue siendo el default.
  window.SucursalSelector = {
    isConfirmado: isConfirmado,
    getState: getState,
    open: function () { openModal(); }
  };

  // ── MIGRACIÓN DE ESTADO PREVIO ────────────────────────────────
  // Estados guardados antes de existir `confirmado` vienen de una elección
  // manual real (el default no existía). Se marcan como confirmados para no
  // molestar con el popup a quien ya había elegido tienda.
  function migrarEstadoLegacy() {
    var state = getState();

    if (!state || !state.id) return;
    if (typeof state.confirmado !== 'undefined') return;

    state.confirmado = true;
    saveState(state);
  }

  migrarEstadoLegacy();

  // ── INIT ──────────────────────────────────────────────────────
  cargarCiudades();
  initAutoPopup();
  reconcileCart();

  // El bfcache restaura la página sin re-ejecutar el script; es el caso
  // típico de "volver atrás desde el checkout".
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) reconcileCart();
  });

  // FIX: reescribir sucursal_id tras agregar al carrito por AJAX.
  // Con el carrito vacio Shopify descarta los atributos; al agregar el primer
  // item queda sin sucursal_id y el cart transform no aplica impuestos.
  // Interceptamos /cart/add, reescribimos el atributo y pedimos re-render.
  (function () {
    var origFetch = window.fetch;
    if (typeof origFetch !== 'function' || window.__sucursalAddGuard) return;
    window.__sucursalAddGuard = true;
    window.fetch = function (input) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var pr = origFetch.apply(this, arguments);
      if (!/\/cart\/add(\.js)?(\?|$)/.test(url)) return pr;
      return pr.then(function (resp) {
        var state = getState();
        if (state && state.id) {
          syncCartOnce(state).then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          });
        }
        return resp;
      });
    };
  })();

})();

/* ===== SIO card price fix: corrige precios por zona en superficies cacheadas (busqueda predictiva) ===== */
(function () {
  function fmtCOP(n) { try { return '$' + Number(n).toLocaleString('es-CO'); } catch (e) { return '$' + Math.round(n); } }
  function getZone() {
    try {
      var raw = localStorage.getItem('sucursal_store');
      if (raw) { var st = JSON.parse(raw); if (st && st.id && window.SIO_LOCATION_ZONES) { var z = window.SIO_LOCATION_ZONES[st.id]; if (z) return z; } }
    } catch (e) {}
    return window.SIO_ZONE || window.SIO_DEFAULT_ZONE || null;
  }
  function fixPrices() {
    var zone = getZone();
    if (!zone) return;
    var els = document.querySelectorAll('.f-price[data-sio-zp]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-sio-zfixed') === zone) continue;
      var zp; try { zp = JSON.parse('{' + el.getAttribute('data-sio-zp') + '}'); } catch (e) { continue; }
      if (zp[zone] == null) continue;
      var zpd = null; try { var d = el.getAttribute('data-sio-zpd'); if (d) zpd = JSON.parse('{' + d + '}'); } catch (e) {}
      if (zpd && zpd[zone] != null) {
        var saleSpan = el.querySelector('.f-price__sale .f-price-item--sale');
        var strike = el.querySelector('.f-price__sale .f-price-item--regular s');
        if (saleSpan) saleSpan.textContent = fmtCOP(zpd[zone]);
        if (strike) strike.textContent = fmtCOP(zp[zone]);
      } else {
        var reg = el.querySelector('.f-price__regular .f-price-item--regular');
        if (reg) reg.textContent = fmtCOP(zp[zone]);
      }
      el.setAttribute('data-sio-zfixed', zone);
    }
  }
  function init() {
    fixPrices();
    var ps = document.querySelector('predictive-search') || document.body;
    try {
      var scheduled = false;
      var mo = new MutationObserver(function () { if (scheduled) return; scheduled = true; requestAnimationFrame(function () { scheduled = false; fixPrices(); }); });
      mo.observe(ps, { childList: true, subtree: true });
    } catch (e) {}
    document.addEventListener('sucursal:changed', fixPrices);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
